import type { ReactNode } from "react";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export function EmptyState({ title, description, icon = <Inbox size={26} className="text-brand" /> }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      <div className="inline-flex bg-brand/10 rounded-2xl p-3 mb-4">{icon}</div>
      <h3 className="text-lg font-semibold text-text">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-2">{description}</p>}
    </div>
  );
}
